let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hNZ8l")).then(() => parcelRequire('4yvLS'));